import React, { useEffect, useMemo, useState } from 'react';
import { Input, Table } from 'antd';
import PropTypes from 'prop-types';
import {
  LeftCenteredContainer,
  PopoverContainer,
  CenteredContainer,
  ButtonLink,
  SetNameDiv
} from './styled';
import { orderBy, uniqBy } from 'lodash';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import CarouselHeader from '../../../components/typologies/carousel/CarouselHeader';

const AccordianTable = ({ thresholds = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, []);

  const tableColumns = [
    {
      title: <b>Risk Indicator</b>,
      render: ({ name = '' }) => (
        <LeftCenteredContainer>{name}</LeftCenteredContainer>
      )
    },
    {
      title: <b>Threshold</b>,
      render: ({ threshold = {} }) => (
        <CenteredContainer>
          <Input
            className="small"
            disabled
            value={threshold?.finalValue || threshold?.value}
          />
        </CenteredContainer>
      )
    }
  ];

  const segments = useMemo(() => {
    const uniqSegments = uniqBy(
      thresholds?.map(({ segment }) => ({
        ...segment,
        name: segment?.id <= 0 ? 'Default' : segment?.name
      })) || [],
      'id'
    );

    return orderBy(uniqSegments, 'id', 'asc');
  }, [thresholds]);

  const riskIndicators = useMemo(() => {
    return thresholds?.filter(
      ({ segment }) => segment?.id === segments[currentIndex]?.id
    );
  }, [segments, currentIndex]);

  const prevClick = () => {
    setCurrentIndex(currentIndex - 1);
  };

  const nextClick = () => {
    setCurrentIndex(currentIndex + 1);
  };

  return (
    <PopoverContainer>
      <CarouselHeader
        showViewAll={false}
        totalNoOfSets={segments?.length}
        current={currentIndex + 1}
      />
      <SetNameDiv>
        <ButtonLink
          type="link"
          disabled={currentIndex === 0}
          icon={<LeftOutlined />}
          onClick={prevClick}
        />
        <span>Set - {segments[currentIndex]?.name}</span>
        <ButtonLink
          type="link"
          disabled={currentIndex === segments?.length - 1}
          icon={<RightOutlined />}
          onClick={nextClick}
        />
      </SetNameDiv>
      {riskIndicators?.map(({ id, name, derivedIndicators }, i) => (
        <details key={id} open={i ? false : true}>
          <summary
            className="p-2 mt-2"
            style={{ background: '#F7F7F8', borderRadius: '10px' }}>
            <strong>{name}</strong>{' '}
          </summary>

          <div className="mt-2 ml-4" style={{ backgroundColor: '#fff' }}>
            <Table
              dataSource={derivedIndicators}
              columns={tableColumns}
              pagination={{
                defaultCurrent: 1,
                defaultPageSize: 5,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '15', '20'],
                showTotal: (total) => <small>{total} Records</small>
              }}
            />
          </div>
        </details>
      ))}
    </PopoverContainer>
  );
};

AccordianTable.propTypes = {
  thresholds: PropTypes.array
};

export default AccordianTable;
